import { ReferenceArrayField, ReferenceArrayInput } from "react-admin";
import AutocompleteInputFluid from "./autocompleteInputFluid";
import { WithPermissions } from "../acl/withPermissions";

export const ReferenceInputString = ({
  source,
  reference,
  dataField = "id",
  permissionAction,
  ...rest
}) => {
  return (
    <WithPermissions
      label="ReferenceInputString"
      can={{ resource: reference, action: permissionAction || "list" }}
    >
      <ReferenceArrayInput source={source} reference={reference}>
        <AutocompleteInputFluid
          forceSize="medium"
          filterToQuery={(searchText) => ({ [dataField]: `${searchText}` })}
          optionText={dataField}
          optionValue={dataField}
          {...rest}
        />
      </ReferenceArrayInput>
    </WithPermissions>
  );
};

export const ReferenceFieldString = ({ source, reference, ...rest }) => {
  return (
    <WithPermissions
      label="ReferenceFieldString"
      can={{ resource: reference, action: "list" }}
    >
      <ReferenceArrayField source={source} reference={reference} {...rest} />
    </WithPermissions>
  );
};
